//
// VisualElement.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./actions/AbstractAction";
import "../common/text/RichTextString";
import "../common/ConditionReference";
import "../../controllers/visualElements/VisualElementController";
import "../common/BIRDProperty";
import "./InteractionApplicability";

var VisualElement = createModule("BIRD::VisualElement", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        longDescription: 7,
        controller: 1,
        description: 7,
        label: 7,
        footnote: 1,
        styleClass: 7,
        selectionDisabled: 2,
        title: 1,
        applyDynamicBrushes: 4,
        applyDynamicFilters: 4,
        autoLabel: 2,
        editorProperties: [1],
        name: 7,
        action: 1,
        disabled: 2,
        conditions: [1],
    },
    ,
    ,
    {
        generateController: [1],
    },
    ,
    ,
]);
export default VisualElement;
